import { createReducer, on } from '@ngrx/store';
import { Attribute } from '@models/attribute.model';
import {
  attributeCreated,
  attributeDeleted,
  attributesFetched,
  attributeUpdated,
  cannotCreateAttribute,
  cannotDeleteAttribute,
  cannotFetchAttributes,
  cannotUpdateAttribute,
  createAttribute,
  deleteAttribute,
  fetchAttributes,
  setAttributeDetail,
  updateAttribute,
} from '../actions/attribute.actions';
import { SharedState } from './index';

export interface AttributeState extends SharedState {
  attributes: Attribute[];
  selectedAttribute?: string;
}

export const initialAttributeState: AttributeState = {
  loaded: false,
  isLoading: false,
  error: '',
  attributes: [],
}

export const attributeReducer = createReducer(
  initialAttributeState,
  on(fetchAttributes, (state) => ({...state, isLoading: true, error: '', loaded: false})),
  on(attributesFetched, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    attributes: payload
  })),
  on(cannotFetchAttributes, (state, {error}) => ({...state, isLoading: false, loaded: false, error, attributes: []})),
  on(updateAttribute, createAttribute, deleteAttribute, (state) => ({
    ...state,
    isLoading: true,
    error: '',
    loaded: false
  })),
  on(attributeUpdated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    attributes: state.attributes.map(a => a.id === payload.id ? payload : a)
  })),
  on(attributeCreated, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    attributes: [...state.attributes, payload]
  })),
  on(setAttributeDetail, (state, {payload}) => ({
    ...state,
    selectedAttribute: payload
  })),
  on(attributeDeleted, (state, {payload}) => ({
    ...state,
    isLoading: false,
    loaded: true,
    error: '',
    attributes: state.attributes.filter(a => a.id !== payload)
  })),
  on(cannotUpdateAttribute, cannotCreateAttribute, cannotDeleteAttribute, (state, {error}) => ({
    ...state,
    isLoading: false,
    loaded: false,
    error
  })),
);
